<template>
  <FilterDropdown :options="options" @select:change="onChange" />
</template>

<script lang="ts">
import type { SelectOptions } from '@/types/Components/SelectOptions'
import { computed, defineComponent, type Ref } from 'vue'
import { DISTRIBUTION_CHANNEL } from '@/const/AssignmentListQueryFilters'
import { BOX, LETTER, PACKAGE, PARCEL } from '@/const/DistributionChannels'
import { useAccountStore } from '@/store/account'
import { useAssignmentStore } from '@/store/assignment'
import FilterDropdown from '@/views/Components/PageParts/FilterDropdown.vue'

export default defineComponent({
  name: 'DistributionChannelFilter',
  components: { FilterDropdown },
  setup() {
    const assignmentStore = useAssignmentStore()
    const accountStore = useAccountStore()

    const isStaff: Ref<boolean> = computed(() => accountStore.isStaff)
    const options: SelectOptions[] = isStaff.value
      ? [
          { value: '', text: 'Distribution channel' },
          { value: PACKAGE, text: 'Packet' },
          { value: PARCEL, text: 'Parcel' },
          { value: BOX, text: 'Parcel Locker' },
          { value: LETTER, text: 'Letter' },
        ]
      : [
          { value: '', text: 'Distribution channel' },
          { value: PACKAGE, text: 'Packet' },
          { value: PARCEL, text: 'Parcel' },
        ]

    const onChange = (value: string) => {
      assignmentStore.updateFilterValue({ key: DISTRIBUTION_CHANNEL, value })
    }

    return {
      onChange,
      options,
    }
  },
})
</script>
